<template>
    <v-card class="elevation-1">
        <v-toolbar flat height="37">
            <span class="primary--text font-weight-bold">
                MY REQUESTS
            </span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-data-table
            :headers="isMobile ? header_mobile : header"
            :items="processedItems"
            :loading="loading"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="paginationSync"
        >
            <template v-slot:items="props">
                <tr @click="viewDetails(props.item)" class="clickable" :title="`Click to view ${props.item.requestType} details`">
                    <td>{{ props.item.requestType }}</td>
                    <td v-if="!isMobile">{{ formatCreatedDate(props.item.createdOn) }}</td>
                    <td>
                        <span :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</span>
                    </td>
                    <td v-if="!isMobile">
                        <v-chip v-if="props.item.approver" class="user-chip-container" small>
                            <v-avatar>
                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.approver.userId)"></v-img>
                            </v-avatar>
                            {{props.item.approver.firstName}} {{props.item.approver.lastName}}
                        </v-chip>
                    </td>
                    <td v-if="!isMobile">{{ formatCreatedDate(props.item.displayDate) }}</td>
                </tr>
            </template> 
        </v-data-table>
    </v-card>
</template>

<script>

import approvalInboxApi from '@/api/approvalinbox'
import awsS3Helper from '@/helpers/aws-s3'
import commonfn from '@/common/functions'       //for refactor
import rowsPerPageItems from '@/constants/rows-per-page'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'
import { formatCreatedDate } from '@/helpers/date-helpers'

const ROUTE_MAP = {
    'ATTENDANCE_CORRECTION': '/myattendance/corrections/details/',
    'TIME_OFF': '/myattendance/timeoff/details/',
    'OVERTIME': '/myattendance/overtime/details/',
    'REIMBURSEMENT': '/finance/myreimbursements/',
    'CASH_ADVANCE': '/finance/mycashadvances/',
    'LOAN_PAYMENT': '/finance/myloans/'
};

export default {     
    name: 'MyRequests',
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            rowsPerPageItems,
            awsS3Helper,
            commonfn,
            formatCreatedDate,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            header: [
                { text: 'Type', align: 'left', width: '25%', value: 'requestType', sortable: true },
                { text: 'Filed On', align: 'left', width: '25', value: 'createdOn', sortable: true },
                { text: 'Status', align: 'left', width: '15%', value: 'status', sortable: true },
                { text: 'Approver', align: 'left', width: '20%', value: 'displayApprover', sortable: true },
                { text: 'Date', align: 'left', width: '15%', value: 'displayDate', sortable: true },
            ],
            header_mobile: [
                { text: 'Type', align: 'left', width:'50%', value:'requestType', sortable:true },
                { text: 'Status', align: 'left', width: '50%', value: 'status', sortable: true }
            ],
            error: false,
            errorMessage: '',
            loading: false,
            myRequests: []
        }
    },
    methods: {
        viewDetails(data) {
            if (data.requestTypeCode === 'TIMESHEET') {
                return this.$router.push(`/myattendance/timesheet/${data.cutoffId}/${this.$store.state.userId}`);
            }

            const baseRoute = ROUTE_MAP[data.requestTypeCode];
            if (baseRoute) {
                this.$router.push(`${baseRoute}${data.requestId}`);
            }
        },
        async getMyRequests() {
            try {
                this.loading = true
                const response = await approvalInboxApi.getMyRequests()
                if (response && response.status == 200) {
                    this.myRequests = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    created() {
        this.getMyRequests()
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        processedItems() {
            return this.myRequests.map(item => {
                // Determine the correct approver and date based on status
                const isApproved = item.status === commonfn.getStatusCode('Approved')
                
                return {
                    ...item,
                    displayApprover: item.Approver ? item.Approver.lastName : null,
                    displayDate: isApproved ? item.approvedOn : item.updatedOn
                };
            });
        }
    }
}
</script>